module.exports = __webpack_public_path__ + "img/cookie.c8b90425.svg";